import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  model,
  output,
  Signal,
  viewChild,
} from '@angular/core';
import { DsBoxModule, DsModalModule } from '@bmw-ds/components';

import { useI18n } from '../../../../i18n/services/i18n.service';
import { PaginationProvider } from '../../../../utils/pagination/pagination.provider';
import { modalOpenOrClosing } from '../../../../utils/signal/modalOpenOrClosing';
import { AddCustomerToVehicleModalContainer } from './add-customer-to-vehicle-modal.container';

@Component({
  selector: 'cdf-add-customer-to-vehicle-modal-wrapper',
  imports: [DsBoxModule, DsModalModule, AddCustomerToVehicleModalContainer],
  providers: [PaginationProvider],
  template: `
    <ds-modal [ds-modal-trigger-for]="modal" [(isModalOpen)]="open" #modal size="lg">
      <ds-box-header>
        {{ i18n('vehicles.addCustomerToVehicle.heading') }}
        <span class="text-regular text-neutral d-inline">({{ paginationProvider.stepString() }})</span>
      </ds-box-header>
      <ds-box-content spacing="none">
        @if (openOrClosing()) {
          <cdf-add-customer-to-vehicle-modal
            [vin]="vin()"
            (cancelModal)="cancelModal.emit(); open.set(false)"
            (completeModal)="completeModal.emit($event); open.set(false)"
          />
        }
      </ds-box-content>
    </ds-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddCustomerToVehicleModalWrapper {
  protected readonly i18n = useI18n();
  protected readonly paginationProvider = inject(PaginationProvider);

  readonly vin = input.required<string>();
  readonly open = model(false);

  readonly cancelModal = output();
  readonly completeModal = output<string>();

  readonly modal: Signal<ElementRef<HTMLElement>> = viewChild.required('modal', { read: ElementRef });

  protected readonly openOrClosing = modalOpenOrClosing(this.open, this.modal);
}
